import {
  SCANYE_DOCUMENT_STATUS_PARTIAL,
  SCANYE_DOCUMENT_STATUS_PENDING,
  SCANYE_DOCUMENT_STATUS_RUNNING,
  SCANYE_DOCUMENT_STATUS_SUCCESS,
} from '../constants/ocr/scanye/ScanyeOCR';

export const OCR_PROCESSING_STATUSES = [
  SCANYE_DOCUMENT_STATUS_PENDING,
  SCANYE_DOCUMENT_STATUS_RUNNING,
  SCANYE_DOCUMENT_STATUS_PARTIAL,
];

export const isOcrProcessing = file => OCR_PROCESSING_STATUSES.includes(file?.ocr?.status);

const hasEntries = value => Array.isArray(value)
  ? value.length > 0
  : !!value && typeof value === 'object' && Object.keys(value).length > 0;

export const hasOcrMarkerPayload = ocr => hasEntries(ocr?.data) || hasEntries(ocr?.texts);

export const mergeFileSnapshot = (currentFile, incomingFile) => {
  if (!currentFile || currentFile.id !== incomingFile?.id) {
    return incomingFile;
  }

  const currentOcr = currentFile.ocr;
  const incomingOcr = incomingFile.ocr;

  if (!currentOcr) {
    return incomingFile;
  }

  if (!incomingOcr
    || (currentOcr.status === SCANYE_DOCUMENT_STATUS_SUCCESS
      && incomingOcr.status !== SCANYE_DOCUMENT_STATUS_SUCCESS)) {
    return {
      ...incomingFile,
      ocr: currentOcr,
    };
  }

  if (currentOcr.status === SCANYE_DOCUMENT_STATUS_SUCCESS
    && incomingOcr.status === SCANYE_DOCUMENT_STATUS_SUCCESS
    && hasOcrMarkerPayload(currentOcr)
    && !hasOcrMarkerPayload(incomingOcr)) {
    return {
      ...incomingFile,
      ocr: currentOcr,
    };
  }

  return incomingFile;
};

export const updateFileCollection = (files, incomingFile, appendIfMissing = false) => {
  const hasFile = files.some(file => file.id === incomingFile?.id);

  if (!hasFile) {
    return appendIfMissing && incomingFile ? [...files, incomingFile] : [...files];
  }

  return files.map(file => file.id === incomingFile.id
    ? mergeFileSnapshot(file, incomingFile)
    : file);
};

export const reconcileFileCollection = (currentFiles, incomingFiles) => incomingFiles.map(incomingFile => {
  const currentFile = currentFiles.find(file => file.id === incomingFile.id);
  return mergeFileSnapshot(currentFile, incomingFile);
});

export const synchronizeSelectedFiles = (selectedFiles, files) => selectedFiles.map(selectedFile =>
  files.find(file => file.id === selectedFile.id) || selectedFile);
